import React from "react";
import {
  Input,
  Row,
  Typography,
  Select,
  Form,
  Divider,
  Col,
  Tooltip,
  InputNumber,
  Switch,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig, staticConfig } from "../../../product.config";

const { Title, Text } = Typography;

const SettingsForm = (props) => {
  const {
    onFinish,
    form,
    lockinPeriodFrequencyTypeOptions,
    taxGroupOptions,
    formData,
    setIsDormancyTrackingActive,
  } = props;
  const checkAllowOverdraft = Form.useWatch("allowOverdraft", form);
  // const checkLienAllowed = Form.useWatch("lienAllowed", form);
  const checkWithHoldTax = Form.useWatch("withHoldTax", form);
  const checkIsDormancyTracking = Form.useWatch("isDormancyTrackingActive", form);

  const handleDormancyTracking = (e) => {
    setIsDormancyTrackingActive(e);
  };

  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {"Settings Information"}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.minimumOpeningBalance} name={"minRequiredOpeningBalance"}>
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.lockInPeriod} name={"lockinPeriodFrequency"}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockinPeriodFrequencyType}
            name={"lockinPeriodFrequencyType"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              options={lockinPeriodFrequencyTypeOptions}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"withdrawalFeeForTransfers"}
            label={
              <Tooltip title={labelConfig.applyWithdrawalFeeForTransfers}>
                {BOM.SubstringFormat(labelConfig.applyWithdrawalFeeForTransfers, 20)}
              </Tooltip>
            }
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNoData}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.balanceRequiredForInterestCalculation}>
                {BOM.SubstringFormat(labelConfig.balanceRequiredForInterestCalculation, 20)}
              </Tooltip>
            }
            name={"minBalanceForInterestCalculation"}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"enforceMinRequiredBalance"} label={labelConfig.enforceMinimumBalance}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNoData}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.minimumBalance} name={"minRequiredBalance"}>
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"allowOverdraft"} label={labelConfig.isOverdraftAllowed}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
            />
          </Form.Item>
        </Col>

        {checkAllowOverdraft && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.maxOverdraftAmountLimit}>
                  {BOM.SubstringFormat(labelConfig.maxOverdraftAmountLimit, 20)}
                </Tooltip>
              }
              name={"overdraftLimit"}
            >
              <Input />
            </Form.Item>
          </Col>
        )}
        {checkAllowOverdraft && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.nominalAnnualInterestForOverdraft}>
                  {BOM.SubstringFormat(labelConfig.nominalAnnualInterestForOverdraft, 20)}
                </Tooltip>
              }
              name={"nominalAnnualInterestRateOverdraft"}
            >
              <Input />
            </Form.Item>
          </Col>
        )}

        {checkAllowOverdraft && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.minOverdraftRequiredForInterestCalculation}>
                  {BOM.SubstringFormat(labelConfig.minOverdraftRequiredForInterestCalculation, 20)}
                </Tooltip>
              }
              name={"minOverdraftForInterestCalculation"}
            >
              <Input />
            </Form.Item>
          </Col>
        )}
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"lienAllowed"} label={labelConfig.isLienAllowed}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
            />
          </Form.Item>
        </Col>

        {checkLienAllowed && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.maximumLienAmountLimit}>
                  {BOM.SubstringFormat(labelConfig.maximumLienAmountLimit, 20)}
                </Tooltip>
              }
              name={"maxAllowedLienLimit"}
            >
              <Input />
            </Form.Item>
          </Col>
        )} */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"withHoldTax"} label={labelConfig.iswithholdTaxApplicable}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
            />
          </Form.Item>
        </Col>

        {checkWithHoldTax && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.taxGroup} name={"taxGroupId"}>
              <Select
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                }
                showSearch
                allowClear
                options={taxGroupOptions}
              />
            </Form.Item>
          </Col>
        )}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"isDormancyTrackingActive"} label={labelConfig.enableDormancyTracking}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
              onChange={handleDormancyTracking}
            />
          </Form.Item>
        </Col>

        {checkIsDormancyTracking && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.numberOfDaysToInactiveSubStatus}>
                    {BOM.SubstringFormat(labelConfig.numberOfDaysToInactiveSubStatus, 20)}
                  </Tooltip>
                }
                name={"daysToInactive"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Number of Days to Inactive Sub-status"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.numberOfDaysToDormantSubStatus}>
                    {BOM.SubstringFormat(labelConfig.numberOfDaysToDormantSubStatus, 20)}
                  </Tooltip>
                }
                name={"daysToDormancy"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Number of Days to Dormant Sub-status"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.numberOfDaysToEscheat}>
                    {BOM.SubstringFormat(labelConfig.numberOfDaysToEscheat, 20)}
                  </Tooltip>
                }
                name={"daysToEscheat"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Number of Days to Escheat"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </>
        )}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name={"isDomestic"} label={labelConfig.domesticProduct}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SettingsForm;
